import Swal from "sweetalert2";

export const forgroundNotificationHandler = (payload) => {
  const title =
    payload.notification?.title || payload.data?.title || "پیام جدید";
  const body = payload.notification?.body || payload.data?.body || "متن پیام";
  const notifImage = payload.notification?.image || payload.data?.image || "";
  const icon = "/Assets/Images/PWAIcons/192x192.png";

  Swal.fire({
    toast: true,
    title: title,
    text: body,
    position: "top",
    showConfirmButton: false,
    timer: 5000,
    timerProgressBar: true,
    direction: "rtl",
    customClass: {
      popup: "custom-swal-toast",
      title: "custom-swal-title",
      content: "custom-swal-text",
    },
    imageUrl: notifImage,
    imageWidth: 320,
    imageHeight: 140,
    imageAlt: "Notification Icon",
  });
  const audio = new Audio("/Assets/audio/notify.wav");
  audio.play().catch(() => {});
  if ("Notification" in window && Notification.permission === "granted") {
    const notif = new Notification(title, { body, icon });
    notif.onclick = () => {
      window.focus();
      notif.close();
    };
  }
};
